export default "//file.bilionpass.com/japandx-portal/0.1.23/static/img/language-selected.3ecede49-9b32ac.svg";